<template>
  <div>
    <Breadcrumb msg1="报表中心" msg2="会员分析" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 15px">
        <el-col :span="6">
          <el-date-picker v-model="dates" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="getData">统计</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4"><div class="stat"><div class="num">{{ data.newMembers || 0 }}</div><div class="sub">新增会员</div></div></el-col>
        <el-col :span="4"><div class="stat"><div class="num">¥{{ data.rechargeTotal || 0 }}</div><div class="sub">储值总额</div></div></el-col>
        <el-col :span="4"><div class="stat"><div class="num">¥{{ data.giftTotal || 0 }}</div><div class="sub">赠送总额</div></div></el-col>
        <el-col :span="4"><div class="stat"><div class="num">{{ data.pointsIssued || 0 }}</div><div class="sub">发放积分</div></div></el-col>
        <el-col :span="4"><div class="stat"><div class="num">{{ data.pointsUsed || 0 }}</div><div class="sub">消耗积分</div></div></el-col>
      </el-row>
      <el-table :data="data.levelDistribution || []" border size="small" style="margin-top: 15px">
        <el-table-column label="等级" prop="levelName"></el-table-column>
        <el-table-column label="人数" prop="count" width="150"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      dates: [],
      data: { levelDistribution: [] }
    }
  },
  created () { this.getData() },
  methods: {
    getData () {
      const params = {}
      if (this.dates && this.dates.length === 2) {
        params.start_date = this.dates[0]
        params.end_date = this.dates[1]
      }
      this.$axios.http.get('/reports/members', { params: params }).then(r => {
        if (r.data.status === 200) this.data = r.data.data
      })
    }
  }
}
</script>

<style scoped>
.stat { background: #f5f7fa; border-radius: 4px; padding: 16px; text-align: center; }
.num { font-size: 20px; color: #409EFF; font-weight: bold; }
.sub { color: #909399; font-size: 13px; margin-top: 4px; }
</style>
